import "./App.css"
import RouterMain from "./router"
import "bootstrap/dist/css/bootstrap.min.css"

function App() {
  return (
    <>
      <RouterMain />
    </>
  )
}

export default App
